import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

// Css
import { Form } from './styles';

// Js
import { useForm } from '../../../Components/General/Form/useForm'
import { GlobalContext } from '../../../Global/GlobalContext';
import { getSingleDeceased, updateDeceased } from '../../../Global/api';
import { uploadImage } from '../../../Infra/General/ImageHelpers';
import ValidationRequired from '../../../Infra/General/Validation/ValidationRequired';

// Components
import Input from '../../../Components/General/Form/Input'
import InputFile from '../../../Components/General/Form/InputFile';
import ButtonOne from '../../../Components/General/Buttons/ButtonOne';
import Textarea from '../../../Components/General/Form/Textarea';

const Update = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const { setLoading, showMessage } = React.useContext(GlobalContext);

    // Url
    const arrPath = location.pathname.split('/');
    const id = arrPath[arrPath.length - 1];

    // Form
    const formRef = React.useRef(null);
    const name = useForm();
    const content = useForm();
    const birthday = useForm();
    const defeat = useForm();
    const image = useForm();
    const [imageExtraInf, setImageExtraInf] = React.useState('');
    const imageRef = React.useRef(null);


    React.useEffect(() => {
        setLoading(1);

        getSingleDeceased(id)
            .then(res => {
                setLoading(0);
                
                name.setValue(res.data().name);
                content.setValue(res.data().content);
                birthday.setValue(res.data().birthday);
                defeat.setValue(res.data().defeat);
                setImageExtraInf(res.data().image)
            })
            .catch(res => {
                setLoading(0);
                showMessage('O item foi removido com sucesso', 200);
                navigate('/dashboard/falecidos');
            });
    }, [])

    function onSubmit(e){
        e.preventDefault();
        
        const validation = new ValidationRequired(formRef.current);

        if(validation.isValid()) saveNewItem();
    }

    function saveNewItem(){
        setLoading(1);
        
        let imageFile = imageRef.current.files[0];
        let imageUpload = null;
        if(imageFile) imageUpload = uploadImage(imageFile, 'deceased');
        

        Promise.all([imageUpload]).then(image => 

            updateDeceased({
                "name": name.value,
                "content": content.value,
                "birthday": birthday.value,
                "defeat": defeat.value,
                "image": image[0] ? image[0] : imageExtraInf
            }, id)
            .then(res => {
                showMessage('Dados salvos com sucesso', 200);
                setLoading(0);
                
                if(image[0]) setImageExtraInf(image[0]);
            })
            .catch(res => {
                setLoading(0);
                showMessage("Ocorreu um erro ao tentar salvar os dados", 400)
            })

        )
        .catch(err => {
            setLoading(0);
            showMessage("Ocorreu um erro ao tentar fazer o upload do arquivo", 400)
        });
    }

    return (
        <Form ref={formRef}>
            <h2>Editar Item</h2>

            <div className="inputs">
                <Input 
                    label="Nome"
                    name="name"
                    type="text"
                    validName="required"
                    className="input-standard"
                    {...name}
                />

                <Input 
                    label="Nascimento"
                    name="birthday"
                    type="text"
                    className="input-standard"
                    {...birthday}
                />

                <Input 
                    label="Falecimento"
                    name="defeat"
                    type="text"
                    className="input-standard"
                    {...defeat}
                />


                <Textarea 
                    label="Conteúdo"
                    name="content"
                    type="text"
                    className="input-standard"
                    {...content}
                />

                <InputFile 
                    name="Imagem"
                    label="image (358 x 166)" 
                    reference={imageRef}
                    className="input-standard"
                    extraInformation={imageExtraInf}
                    {...image}
                />
            </div>
            
            <ButtonOne
                width={200}
                height={50}
                onClick={onSubmit}
            >
                Enviar
            </ButtonOne>
        </Form>
    )
}

export default Update
